const floatFormatter = (value, options = {}) => {
	const { toFixed = 2, locale, floatsPrecisionOnly } = options
	if(value === null || isNaN(value)) {
		return null
	}
	const usePrecision = floatsPrecisionOnly ? !Number.isInteger(value) : true
	return Number(value).toLocaleString(locale, { ...usePrecision && {
		minimumFractionDigits: toFixed,
		maximumFractionDigits: toFixed
	} })
}

export default floatFormatter
